module.exports = __webpack_public_path__ + "static/img/issue_matrix_202512.69ca50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/stakeholder-identification/issue_matrix_202512.jpg
// module id = JeUh
// module chunks = 100